import { NgModule } from '@angular/core';

import { ComponentsModule } from 'src/app/shared/components/components.module';
import { SharedModule } from '@shared/shared.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

@NgModule({
  imports: [SharedModule, ComponentsModule],
  declarations: [NotFoundComponent, ForbiddenComponent, UnauthorizedComponent],
})
export class ErrorPagesModule {}
